import { UserManagerService } from './../../shared/services/user-manager.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Globals } from 'src/app/shared/services/globals';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SidebarService } from '../services/sidebar.service';
import { GenericVm } from 'src/app/shared/models/system/generic-vm';
declare function  sideBar() : void;
@Component({
  selector: 'app-start-sidebar',
  templateUrl: './start-sidebar.component.html',
  styleUrls: ['./start-sidebar.component.css']
})
export class StartSidebarComponent implements OnInit , AfterViewInit {

  constructor(public global: Globals ,private translate: TranslateService, public userManagerService: UserManagerService,public router: Router,
   public sidebarService: SidebarService) { }
userRoles;
selectedRole;
userRolesDetails;
selectedRoleDetails;

selectedDependant: string;
  empDependants;
  loginUserId: string;
  loginUserName: string;
  loginPatientId: number;
  isEmpolyee: boolean;
  ngOnInit() {

// alert(this.global.Role)
    //this.userRolesDetails=this.global.RolesDetails;
    this.userRolesDetails = this.global.UserData.rolesDetails;
   this.userRoles=this.global.UserData.roleCode;
   this.selectedRole=this.global.Role;
   this.selectedRoleDetails=this.userRolesDetails[0];

   this.selectedDependant = this.global.LoginFullName;
   this.selectedRole = this.global.Role;

   this.isEmpolyee = false;

   if (this.global.Role == 'EmployeePatient') {
     this.isEmpolyee = true;
   }
   else {
     this.isEmpolyee = false;
   }


  }



  logOut()
  {
    this.global.Role=null;
    this.userManagerService.logout();
  }
  ngAfterViewInit() {

 
   sideBar();

   // sideBar();
  //  sideBar();

  }

  ChangeUserRole(role){
    //alert(role);
    this.selectedRole=role;
    this.global.Role=role;


    if (this.router.url != '/auth') {
      this.router.navigateByUrl('/auth');
    }

   // alert(this.global.Role);
  }
}
